import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle}</title>
                    <meta name="description" content="Website FX – Professional website design and development services for growing businesses. We build modern, responsive, SEO-friendly websites that attract customers and drive results." />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
